import { HttpClient } from "../../../services/http/http-client";

export const checkVATNumber = (vatNumber) => {
  // let country_code = vatNumber.slice(0, 2);
  // let number = vatNumber.slice(2);
  // let vat_url = `http://ec.europa.eu/taxation_customs/vies/vatResponse.html?&action=check&memberStateCode=${country_code}&number=${number}`;
  let vat_url = `${HttpClient.getBaseUrl()}/contacts.pl?section=documents&action=vat_info&vat_no=${vatNumber}`;
  window.open(vat_url);
};